/**
 * Sanitizes WhatsApp text for URL encoding
 * FIX: Uses standard encoding (encodeURIComponent) to handle emojis and special chars correctly.
 * @param {string} rawText - The text to sanitize
 * @returns {string} - URL encoded text
 */
const sanitizeWhatsappText = (rawText) => {
  if (!rawText) return '';

  const cleanText = String(rawText)
    .replace(
      /([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g,
      ''
    )
    .trim();

  return encodeURIComponent(cleanText);
};

/**
 * Normalizes WhatsApp phone number by removing non-digits and country code
 * @param {string} rawPhone - The phone number to normalize
 * @returns {string|null} - Normalized phone number or null
 */
const normalizeWhatsappPhone = (rawPhone) => {
  if (rawPhone === null || rawPhone === undefined) return null;
  const digits = String(rawPhone).replace(/\D/g, '');
  if (!digits) return null;
  // logic: ensure we strip 55 so we can add it back cleanly later
  return digits.replace(/^55/, '');
};

/**
 * Handles the whatsappIndicator object from order response
 * Opens WhatsApp tab if manual message should be sent
 * @param {Object} whatsappIndicator - The whatsappIndicator object from API response
 */
export function handleWhatsappIndicator(whatsappIndicator) {
  if (!whatsappIndicator) {
    return;
  }

  const { should_send_manual_whatsapp_message, message_text, recipient_phone } =
    whatsappIndicator;

  console.log('Original message_text:', message_text);

  if (!should_send_manual_whatsapp_message) {
    return;
  }

  const sanitizedText = sanitizeWhatsappText(message_text);
  const normalizedPhone = normalizeWhatsappPhone(recipient_phone);

  // Debug logs to verify encoding
  console.log('Sanitized (Encoded) text:', sanitizedText);
  console.log('Normalized phone:', normalizedPhone);

  if (!normalizedPhone || !sanitizedText) {
    console.warn('WhatsApp indicator: Invalid phone or message text');
    return;
  }

  // Construct the final URL
  // Note: sanitizedText is already encoded, so we don't need to do anything else here.
  const whatsappUrl = `https://wa.me/55${normalizedPhone}?text=${sanitizedText}`;

  console.log('Final WhatsApp URL:', whatsappUrl);
  window.open(whatsappUrl, '_blank');
}
